import { render, staticRenderFns } from "./TournamentPositionCard.vue?vue&type=template&id=1a89be4c&scoped=true"
import script from "./TournamentPositionCard.vue?vue&type=script&lang=js"
export * from "./TournamentPositionCard.vue?vue&type=script&lang=js"
import style0 from "./TournamentPositionCard.vue?vue&type=style&index=0&id=1a89be4c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a89be4c",
  null
  
)

export default component.exports